import { render, staticRenderFns } from "./UpdateBanner.vue?vue&type=template&id=166b8edc&"
import script from "./UpdateBanner.vue?vue&type=script&lang=js&"
export * from "./UpdateBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports